import { FC, useState } from "react"
import { Copy, Check, Info } from "lucide-react"
import { ConnectorFormValues } from "../../../../../../../types"

interface WebhookUrlSectionProps {
  values: ConnectorFormValues
  onCopyWebhookUrl: () => void
}

const WebhookUrlSection: FC<WebhookUrlSectionProps> = ({
  values,
  onCopyWebhookUrl
}) => {
  const [copied, setCopied] = useState(false)

  const handleCopy = () => {
    onCopyWebhookUrl()
    setCopied(true)
    setTimeout(() => setCopied(false), 2000)
  }

  return (
    <div className="bg-blue-50 border-2 border-blue-300 rounded-lg p-5 shadow-sm">
      <div className="mb-3">
        <h3 className="text-lg font-semibold text-blue-900 mb-1">
          Webhook Endpoint URL
        </h3>
        <p className="text-sm text-blue-700">
          Configure your CRM to send webhooks to this URL
        </p>
      </div>

      <div className="flex items-center space-x-2 bg-white rounded-md p-3 border border-blue-200">
        <input
          type="text"
          value={values.incoming_webhook_url || ""}
          readOnly
          className="flex-1 px-3 py-2.5 border-0 font-mono text-sm text-gray-900 focus:outline-none focus:ring-0 bg-transparent"
        />
        <button
          type="button"
          onClick={handleCopy}
          className="px-4 py-2.5 bg-blue-600 text-white rounded-md hover:bg-blue-700 transition-colors flex items-center space-x-2 font-medium"
        >
          {copied ? (
            <>
              <Check size={16} />
              <span>Copied!</span>
            </>
          ) : (
            <>
              <Copy size={16} />
              <span>Copy URL</span>
            </>
          )}
        </button>
      </div>

      <div className="mt-3 flex items-start space-x-2 text-sm text-blue-800 bg-blue-100 rounded-md p-3">
        <Info className="w-4 h-4 mt-0.5 flex-shrink-0" />
        <p>
          This URL is unique and secure. It was generated when you created this
          connector. Copy it to configure your CRM's webhook settings.
        </p>
      </div>
    </div>
  )
}

export default WebhookUrlSection
